const konami = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13];
let pressed = [];

// ↑ ↑ ↓ ↓ ← → ← → B A

// Start listening for our precious Konami keys!
window.addEventListener('keyup', (e) => {
  // Are we starting a konami sequence?
  if (pressed.length === 0 && e.keyCode !== konami[0]) {
    return;
  }

  // Add to the list of pressed buttons
  pressed.push(e.keyCode);

  // Reset if it's not matching anymore
  if (e.keyCode !== konami[pressed.length - 1]) {
    pressed = [];
    return;
  }

  // Does it match? If so, have fun!
  if (pressed.join('') === konami.join('')) {
    const { classList } = document.querySelector('html');
    classList.toggle('has-egg');

    // Reset
    pressed = [];
  }
});
